import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import {
  fetchLabByRkun,
  fetchObatByRkun,
} from "../../../redux/actions/history";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import ActionDialog from "../../../components/ActionDialog";
import AccordionObat from "../../../components/AccordionObat";
import AccordionLabs from "./AccordionLabs";

type Props = {
  actFetchLabByRkun: ({ rkun_id }: any) => void;
  stateHistoryLab: any;
  open: boolean;
  setOpen: (open: boolean) => void;
};

const HistoryLaboratorium = (props: Props) => {
  const { actFetchLabByRkun, stateHistoryLab, open, setOpen } = props;
  const { id } = useParams();

  React.useEffect(() => {
    if (open) actFetchLabByRkun({ rkun_id: id });
    return () => {};
  }, [open]);

  return (
    <>
      <ActionDialog
        open={open}
        label="Laboratorium"
        setOpen={(val: boolean) => setOpen(val)}
      >
        <Stack spacing={2}>
          <Box height="1vh"></Box>
          {stateHistoryLab.length == 0 && (
            <Typography variant="body1" align="center">
              Data kosong
            </Typography>
          )}
          {stateHistoryLab?.map((item: any) => (
            <AccordionLabs
              items={item.items}
              tanggal={item.tanggal}
              title={item.id}
              key={item.id}
              link={item.pdf_link}
              isReady={item.is_ready}
            />
          ))}
        </Stack>
      </ActionDialog>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    stateHistoryLab: state.history.laboratorium,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actFetchLabByRkun: ({ rkun_id }: any) =>
      dispatch(fetchLabByRkun({ rkun_id })),
    // actGetAntrianPoli: (id: number) => dispatch(getAntrianPoli(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HistoryLaboratorium);
